// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Agents'">
    <button command-access="AgentBatchFileUploadRegistration" type="button" class="btn btn-primary" ng-click="\$ctrl.batchUpload()">
      Batch upload
    </button>
  </sub-header>

  <branches-list detail-link="/#!/agent-banking/agents"></branches-list>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/branches/agents-branches.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;